import { render, staticRenderFns } from "./EditSqlViewWidget.vue?vue&type=template&id=036a2a74&scoped=true"
import script from "./EditSqlViewWidget.vue?vue&type=script&lang=js"
export * from "./EditSqlViewWidget.vue?vue&type=script&lang=js"
import style0 from "./EditSqlViewWidget.vue?vue&type=style&index=0&id=036a2a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a2a74",
  null
  
)

export default component.exports